import { call, put, takeEvery, all, select } from "redux-saga/effects";
import runbooksService from "../services/runbooks.service";
import { generalActions } from "../actions";
import {
  getRunbooksAttempt,
  getRunbookDetailAttempt,
  getRunbookActionDetailAttempt,
  createRunbookAttempt,
  updateRunbookAttempt,
  deleteRunbookAttempt,
  startRunbookAttempt,
  stopRunbookAttempt,
  createRunbookActionAttempt,
  updateRunbookActionAttempt,
  deleteRunbookActionAttempt,
  completeRunbookActionAttempt,
  duplicateRunbookAttempt,
  duplicateRunbookActionAttempt,
  reorderRunbookActionAttempt,
  updateRunbookFlagAttempt,
} from "../actions/runbooks.actions";
import ACTIONS from "../constants";
import { runbooksPagination } from "../selectors/runbooks.selector";

function* getRunbooks(action) {
  yield put(getRunbooksAttempt.pending);
  try {
    const response = yield call(runbooksService.getRunbooksRequest, action.payload);
    const pagination = JSON.parse(response.headers["x-pagination"]);
    yield put(getRunbooksAttempt.success({ data: response.data, pagination }));
  } catch (error) {
    yield put(getRunbooksAttempt.error(error));
    yield put(generalActions.showToast({ title: "Something went wrong. Please try again later.", type: "error" }));
  }
}

function* getRunbookDetail(action) {
  yield put(getRunbookDetailAttempt.pending);
  try {
    const response = yield call(runbooksService.getRunbookDetailRequest, action.payload.id);
    yield put(getRunbookDetailAttempt.success(response));
  } catch (error) {
    yield put(getRunbookDetailAttempt.error(error));
    yield put(generalActions.showToast({ title: "Something went wrong. Please try again later.", type: "error" }));
  }
}

function* createRunbook(action) {
  const { projectId, payload, onSuccess } = action.payload;
  yield put(createRunbookAttempt.pending);
  try {
    yield call(runbooksService.createRunbookRequest, payload);
    const paginat = yield select(runbooksPagination);
    const response = yield call(runbooksService.getRunbooksRequest, {
      projectId,
      page: 1,
      size: paginat?.PageSize || 10,
    });
    const pagination = JSON.parse(response.headers["x-pagination"]);
    yield put(createRunbookAttempt.success({ data: response.data, pagination }));
    yield put(generalActions.showToast({ title: "Runbook created successfully.", type: "success" }));
    if (onSuccess) onSuccess();
  } catch (error) {
    yield put(createRunbookAttempt.error(error));
    yield put(generalActions.showToast({ title: "Something went wrong. Please try again later.", type: "error" }));
  }
}

function* updateRunbook(action) {
  const { id, projectId, payload, onSuccess } = action.payload;
  yield put(updateRunbookAttempt.pending);
  try {
    yield call(runbooksService.updateRunbookRequest, { id, payload });
    const paginat = yield select(runbooksPagination);
    const response = yield call(runbooksService.getRunbooksRequest, {
      projectId,
      page: paginat?.CurrentPage || 1,
      size: paginat?.PageSize || 10,
    });
    const pagination = JSON.parse(response.headers["x-pagination"]);
    yield put(updateRunbookAttempt.success({ data: response.data, pagination }));
    yield put(generalActions.showToast({ title: "Runbook updated successfully.", type: "success" }));
    if (onSuccess) onSuccess();
  } catch (error) {
    yield put(updateRunbookAttempt.error(error));
    yield put(generalActions.showToast({ title: "Something went wrong. Please try again later.", type: "error" }));
  }
}

function* deleteRunbook(action) {
  const { id, projectId } = action.payload;
  yield put(deleteRunbookAttempt.pending);
  try {
    yield call(runbooksService.deleteRunbookRequest, id);
    const paginat = yield select(runbooksPagination);
    const response = yield call(runbooksService.getRunbooksRequest, {
      projectId,
      page: paginat?.CurrentPage || 1,
      size: paginat?.PageSize || 10,
    });
    const pagination = JSON.parse(response.headers["x-pagination"]);
    yield put(deleteRunbookAttempt.success({ data: response.data, pagination }));
    yield put(generalActions.showToast({ title: "Runbook deleted successfully.", type: "success" }));
  } catch (error) {
    yield put(deleteRunbookAttempt.error(error));
    yield put(generalActions.showToast({ title: "Something went wrong. Please try again later.", type: "error" }));
  }
}

function* startRunbook(action) {
  const { id, onSuccess } = action.payload;
  yield put(startRunbookAttempt.pending);
  try {
    yield call(runbooksService.startRunbookRequest, id);
    const detail = yield call(runbooksService.getRunbookDetailRequest, id);
    yield put(startRunbookAttempt.success(detail));
    if (onSuccess) onSuccess();
  } catch (error) {
    yield put(startRunbookAttempt.error(error));
    yield put(generalActions.showToast({ title: "Something went wrong. Please try again later.", type: "error" }));
  }
}

function* stopRunbook(action) {
  const { id, onSuccess } = action.payload;
  yield put(stopRunbookAttempt.pending);
  try {
    yield call(runbooksService.stopRunbookRequest, id);
    const detail = yield call(runbooksService.getRunbookDetailRequest, id);
    yield put(stopRunbookAttempt.success(detail));
    if (onSuccess) onSuccess();
  } catch (error) {
    yield put(stopRunbookAttempt.error(error));
    yield put(generalActions.showToast({ title: "Something went wrong. Please try again later.", type: "error" }));
  }
}

function* createRunbookAction(action) {
  const { runbookId, payload, onSuccess } = action.payload;
  yield put(createRunbookActionAttempt.pending);
  try {
    yield call(runbooksService.createRunbookActionRequest, { runbookId, payload });
    const detail = yield call(runbooksService.getRunbookDetailRequest, runbookId);
    yield put(createRunbookActionAttempt.success(detail));
    yield put(generalActions.showToast({ title: "Action created successfully.", type: "success" }));
    if (onSuccess) onSuccess();
  } catch (error) {
    yield put(createRunbookActionAttempt.error(error));
    yield put(generalActions.showToast({ title: "Something went wrong. Please try again later.", type: "error" }));
  }
}

function* updateRunbookAction(action) {
  const { runbookId, actionId, payload, onSuccess } = action.payload;
  yield put(updateRunbookActionAttempt.pending);
  try {
    yield call(runbooksService.updateRunbookActionRequest, { runbookId, actionId, payload });
    const detail = yield call(runbooksService.getRunbookDetailRequest, runbookId);
    yield put(updateRunbookActionAttempt.success(detail));
    yield put(generalActions.showToast({ title: "Action updated successfully.", type: "success" }));
    if (onSuccess) onSuccess();
  } catch (error) {
    yield put(updateRunbookActionAttempt.error(error));
    yield put(generalActions.showToast({ title: "Something went wrong. Please try again later.", type: "error" }));
  }
}

function* deleteRunbookAction(action) {
  const { runbookId, actionId } = action.payload;
  yield put(deleteRunbookActionAttempt.pending);
  try {
    yield call(runbooksService.deleteRunbookActionRequest, { runbookId, actionId });
    const detail = yield call(runbooksService.getRunbookDetailRequest, runbookId);
    yield put(deleteRunbookActionAttempt.success(detail));
    yield put(generalActions.showToast({ title: "Action deleted successfully.", type: "success" }));
  } catch (error) {
    yield put(deleteRunbookActionAttempt.error(error));
    yield put(generalActions.showToast({ title: "Something went wrong. Please try again later.", type: "error" }));
  }
}

function* completeRunbookAction(action) {
  const { runbookId, actionId } = action.payload;
  yield put(completeRunbookActionAttempt.pending);
  try {
    yield call(runbooksService.completeRunbookActionRequest, { runbookId, actionId });
    const detail = yield call(runbooksService.getRunbookDetailRequest, runbookId);
    yield put(completeRunbookActionAttempt.success(detail));
  } catch (error) {
    yield put(completeRunbookActionAttempt.error(error));
    yield put(generalActions.showToast({ title: "Something went wrong. Please try again later.", type: "error" }));
  }
}

function* duplicateRunbook(action) {
  const { id, projectId, payload, onSuccess } = action.payload;
  yield put(duplicateRunbookAttempt.pending);
  try {
    yield call(runbooksService.duplicateRunbookRequest, { id, payload });
    const paginat = yield select(runbooksPagination);
    const response = yield call(runbooksService.getRunbooksRequest, {
      projectId,
      page: paginat?.CurrentPage || 1,
      size: paginat?.PageSize || 10,
    });
    const pagination = JSON.parse(response.headers["x-pagination"]);
    yield put(duplicateRunbookAttempt.success({ data: response.data, pagination }));
    yield put(generalActions.showToast({ title: "Runbook duplicated successfully.", type: "success" }));
    if (onSuccess) onSuccess();
  } catch (error) {
    yield put(duplicateRunbookAttempt.error(error));
    yield put(generalActions.showToast({ title: "Something went wrong. Please try again later.", type: "error" }));
  }
}

function* duplicateRunbookAction(action) {
  const { runbookId, actionId, onSuccess } = action.payload;
  yield put(duplicateRunbookActionAttempt.pending);
  try {
    yield call(runbooksService.duplicateRunbookActionRequest, { runbookId, actionId });
    const detail = yield call(runbooksService.getRunbookDetailRequest, runbookId);
    yield put(duplicateRunbookActionAttempt.success(detail));
    yield put(generalActions.showToast({ title: "Action duplicated successfully.", type: "success" }));
    if (onSuccess) onSuccess();
  } catch (error) {
    yield put(duplicateRunbookActionAttempt.error(error));
    yield put(generalActions.showToast({ title: "Something went wrong. Please try again later.", type: "error" }));
  }
}

function* reorderRunbookAction(action) {
  const { runbookId, actionId, payload, onSuccess } = action.payload;
  yield put(reorderRunbookActionAttempt.pending);
  try {
    yield call(runbooksService.reorderRunbookActionRequest, { runbookId, actionId, payload });
    const detail = yield call(runbooksService.getRunbookDetailRequest, runbookId);
    yield put(reorderRunbookActionAttempt.success(detail));
    if (onSuccess) onSuccess();
  } catch (error) {
    yield put(reorderRunbookActionAttempt.error(error));
    yield put(generalActions.showToast({ title: "Something went wrong. Please try again later.", type: "error" }));
  }
}

function* updateRunbookFlag(state) {
  try {
    yield put(updateRunbookFlagAttempt.pending);
    yield call(runbooksService.updateRunbookFlagRequest, state.payload);
    yield put(updateRunbookFlagAttempt.success());
  } catch (error) {
    yield put(
      updateRunbookFlagAttempt.error(error)
    );
  }
}

function* getRunbookActionDetail(action) {
  yield put(getRunbookActionDetailAttempt.pending);
  try {
    const { runbookId, actionId } = action.payload;
    const response = yield call(runbooksService.getRunbookActionDetailRequest, { runbookId, actionId });
    yield put(getRunbookActionDetailAttempt.success(response));
  } catch (error) {
    yield put(getRunbookActionDetailAttempt.error(error));
    yield put(generalActions.showToast({ title: "Something went wrong. Please try again later.", type: "error" }));
  }
}
export default function* runbooksSagas() {
  yield all([
    takeEvery(ACTIONS.RUNBOOKS_CALL, getRunbooks),
    takeEvery(ACTIONS.RUNBOOK_DETAIL_CALL, getRunbookDetail),
    takeEvery(ACTIONS.CREATE_RUNBOOK_CALL, createRunbook),
    takeEvery(ACTIONS.UPDATE_RUNBOOK_CALL, updateRunbook),
    takeEvery(ACTIONS.DELETE_RUNBOOK_CALL, deleteRunbook),
    takeEvery(ACTIONS.RUNBOOK_START_CALL, startRunbook),
    takeEvery(ACTIONS.RUNBOOK_STOP_CALL, stopRunbook),
    takeEvery(ACTIONS.CREATE_RUNBOOK_ACTION_CALL, createRunbookAction),
    takeEvery(ACTIONS.UPDATE_RUNBOOK_ACTION_CALL, updateRunbookAction),
    takeEvery(ACTIONS.DELETE_RUNBOOK_ACTION_CALL, deleteRunbookAction),
    takeEvery(ACTIONS.COMPLETE_RUNBOOK_ACTION_CALL, completeRunbookAction),
    takeEvery(ACTIONS.RUNBOOK_FLAG_CALL, updateRunbookFlag),
    takeEvery(ACTIONS.RUNBOOK_ACTION_DETAIL_CALL, getRunbookActionDetail),
    takeEvery(ACTIONS.DUPLICATE_RUNBOOK_CALL, duplicateRunbook),
    takeEvery(ACTIONS.DUPLICATE_RUNBOOK_ACTION_CALL, duplicateRunbookAction),
    takeEvery(ACTIONS.REORDER_RUNBOOK_ACTION_CALL, reorderRunbookAction),
  ]);
}
